import React from "react";
import classNames from "classnames";
import {
  GOVGR_TABS,
  GOVGR_TABS__PANEL,
  GOVGR_TABS__PANEL_VISIBLE,
} from "../../conf/styles/GovGrTabs";

const GrGovTabArea = ({ value, index, children }) => {
  const selectedTab = parseInt(value) === parseInt(index);
  const wrapperClassName = classNames(GOVGR_TABS__PANEL, {
    [`${GOVGR_TABS__PANEL_VISIBLE}`]: selectedTab,
  });

  return (
    <div className={GOVGR_TABS}>
      {selectedTab && (
        <div id={index} className={wrapperClassName}>
          {children}
        </div>
      )}
    </div>
  );
};

export default GrGovTabArea;
